export const blankSymbol = {
    emoji: 'memo',
    emojiUnicode: '📝',
    colorToken: 'symbol-green-1'
}